import { object, string, number } from "yup";
import { DOSE_MgKg } from "duck";

export const getValidation = () => {
  const nullableNumber = number()
    .nullable()
    .transform(value => (Number.isNaN(value) ? 0 : value));

  const validationSchema = object().shape({
    name: string()
      .default(null)
      .required()
      .nullable(),
    dose: nullableNumber.required(),
    doseUnit: string()
      .required()
      .nullable()
      .default(DOSE_MgKg),
    concentration: nullableNumber.required(),
    totalVolume: nullableNumber,
    labelInstructions: string().default("")
  });

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
